import PnmCard from './PnmCard';

export default PnmCard;
